<template>
  <div>
    <div v-if="step == 1">
      <label>{{ label_select_vehicle_label }}</label>
      <VehicleDropDown
        :for_load_calc="true"
        v-on:selectVehicleLoadrating="selectVehicleLoadrating($event)"
        :label_manufacturer="label_manufacturer"
        :label_model="label_model"
        :label_year="label_year"
        :label_body_type="label_body_type"
        :label_loading="label_loading"
        :label_select="label_select"
        :label_select_vehicle="label_next"
        :vehicle_type_id="getVehicleId"
      ></VehicleDropDown>
    </div>
    <div class="solutions __vehicles" v-if="selectedVehicle && (step == 2)" style="padding: 0px; background-color: #f5f5f5;">
      <div class="vehicles">
        <div class="vehicle-drilldown">
          <div class="form" style="border: 0px">
            <div class="form-content">
              <div class='calculator_summary'>
                <h3 v-if="selectedVehicle" style="font-weight: 700; padding-bottom: 12px;">{{ label_selected_vehicle.toUpperCase() }}</h3>
                <div v-if="selectedVehicle" style="font-weight: 700; padding-bottom: 20px;"> {{ selectedVehicle.full_name }}</div>
              </div>
              <div class="form-row" v-if="isTruckBedProduct && selectedProductLoadRatingLimit">
                <label>{{ label_rhino_rack_system_load_limit }}</label>
                  <input :value="selectedProductLoadRatingLimit" readonly />
              </div>
              <div class="form-row" v-if="isTruckBedProduct">
                <label v-if="isTruckBedProduct">{{ label_load_rating_truck_bed }}</label>
                <input type="number" v-model.trim="ownerManualVehicleLoadRating" />
              </div>
              <div class="form-row" v-if="isRoofProduct">
                <label>{{ symbol_weight_unit === 'lbs' ? label_vehicle_load_rating_us : label_vehicle_load_rating }}</label>
                <input type="number" v-model.trim="vehicleLoadRating" />
              </div>
              <div class="form-row" v-if="false">
                <div>
                  <label>{{ label_stockcode }}</label>
                  <select :disabled="(!vehicleLoadRating) || (vehicleLoadRating <= 0)" name id v-model="selectedProduct">
                    <option v-for="(vehicleRoofRack, index) in vehicleRoofRacks" :key="index" :value="vehicleRoofRack.productId">
                    {{ vehicleRoofRack.stockCode }} - {{ vehicleRoofRack.title }}</option>
                  </select>
                  <div v-if="showNoFitmentAvailable" class="error">{{ label_no_fitment_available  }}</div>
                </div>
              </div>
              <div class="form-row">
                <button
                :disabled="(!selectedProduct) || (isRoofProduct && !vehicleLoadRating && vehicleLoadRating <= 0)"
                class="btn btn-hover btn-primary"
                @click="fetchRating($event)"
                type="button"
                >{{ label_calculate }}</button>
                <button
                class="btn btn-hover btn-primary"
                @click="selectedProduct = null; step--; apiLoadrating = null; apiLoaded = null; vehicleLoadRating = null;"
                type="button"
                >{{ label_back }}</button>
              </div>
              <div class="form-row" v-if="apiLoaded">
                <hr>
                <div style="font-weight: 700; padding: 12px 0px;">{{ label_result }}</div>
                <div v-if="!apiSuccess" class="label_no_product_vehicle_match">{{ label_no_product_vehicle_match  }}</div>
                <div v-if="apiSuccess && apiLoadrating" class="label_product_vehicle_match">
                  <div v-if="apiLoadrating.loadRating > 0">{{ label_dynamic_load_rating }}: <b>{{ Math.floor(apiLoadrating.loadRating * unitConvertor) }}{{ symbol_weight_unit }}</b> </div>
                  <div v-if="apiLoadrating.staticLoadRating > 0">{{ label_static_load_rating }}: <b>{{ Math.floor(apiLoadrating.staticLoadRating * unitConvertor) }}{{ symbol_weight_unit }}</b> </div>
                  <div v-if="isRoofProduct && selectedProductObj && (selectedProductObj.weight > 0)">{{ label_system_weight }}: <b>{{ Math.ceil(selectedProductObj.weight * unitConvertor) }}{{ symbol_weight_unit }}</b></div>
                  <div v-if="isTruckBedProduct && selectedProductObj && (selectedProductObj.weight > 0)">{{ label_system_weight }}: <b>{{ Math.ceil(selectedProductObj.weight * unitConvertor) }}{{ symbol_weight_unit }}</b></div>
                  <div v-if="isRoofProduct && apiLoadrating.loadRating > 0">{{ label_payload_capacity }}: <b>{{ (apiLoadrating.loadRating - selectedProductObj.weight) > 0 ? Math.floor((apiLoadrating.loadRating - selectedProductObj.weight) * unitConvertor) : 0 }}{{ symbol_weight_unit }}</b></div>
                  <div v-if="isTruckBedProduct && apiLoadrating.loadRating > 0">{{ label_payload_capacity_truck_bed }}: <b>{{ (apiLoadrating.loadRating - selectedProductObj.weight) > 0 ? Math.floor((apiLoadrating.loadRating - selectedProductObj.weight) * unitConvertor) : 0 }}{{ symbol_weight_unit }}</b></div>
                </div>
                  <div v-if="apiLoadrating.offroadLoadRating > 0 && apiLoadrating.offroadLoadRating !== -1">{{ label_offroad_load_rating }}: <b>{{ Math.floor((Math.floor((apiLoadrating.loadRating - selectedProductObj.weight) * unitConvertor)) / apiLoadrating.offroadLoadRating) }}{{ symbol_weight_unit }}</b></div>
                  <div v-if="isRoofProduct && apiLoadrating.offroadLoadRating == 0  && apiLoadrating.offroadLoadRating !== -1">{{ label_offroad_load_rating }}: <b>{{ (apiLoadrating.loadRating - selectedProductObj.weight) > 0 ? Math.floor((apiLoadrating.loadRating - selectedProductObj.weight) * unitConvertor) : 0 }}{{ symbol_weight_unit }} {{ label_offroad_load_reduction_does_not_apply }}</b></div>
                  <div v-if="isTruckBedProduct && apiLoadrating.offroadLoadRating == 0  && apiLoadrating.offroadLoadRating !== -1">{{ label_offroad_load_rating }}: <b>{{ (apiLoadrating.loadRating - selectedProductObj.weight) > 0 ? Math.floor((apiLoadrating.loadRating - selectedProductObj.weight) * unitConvertor) : 0 }}{{ symbol_weight_unit }} {{ label_offroad_load_reduction_does_not_apply_truck_bed }}</b></div>
                  
                  <!-- <div v-if="apiLoadrating.offroadConsiderations">{{ label_offroad_considerations }}: {{ apiLoadrating.offroadConsiderations}}</div> -->
                  <!-- <div>{{ label_special_note }}</div> -->
                  <div v-if="isRoofProduct">
                    <br/><span v-html="load_rating_disclaimer"></span>
                  </div>
                  <div v-if="isTruckBedProduct">
                      <br/><span v-html="load_rating_disclaimer_truck_bed"></span>
                  </div>
                </div>
                <div class="overlay" dusk="loading_overlay" v-show="loading">
                  <p class="loading">
                    <img src="/cdn/images/loading.gif" width="100" />
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  import VehicleDropDown from "./form-wizard-vehicle.vue";

  export default {
    name: "load-rating-product",
    components: {
      VehicleDropDown,
      VehicleDropDown: VehicleDropDown
    },
    data() {
      return {
        vehicleId: null,
        productId: null,
        vehicleLoadRating: null,
        ownerManualVehicleLoadRating: null,
        selectedProduct: null,
        vehicleRoofRacks: [],
        showNoFitmentAvailable: false,
        selectedVehicle: null,
        step: 1,
        apiUrl: `api/calculate-loadrating`,
        apiVehicleProducts: `api/vehicle/products/`,
        apiLoaded: false,
        apiSuccess: false,
        apiLoadrating: null,
        loading: false,
        unitConvertor: 1,
        vehicleProductsApiResponse: [],
      };
    },
    props: {
      label_special_note: {
        type: String,
        default: "Special Note: Off-Road Load Rating  can be calculated by using the formula provided in your Rhino-Rack fitting instruction.",
      },
      label_result: {
        type: String,
        default: "Result"
      },
      label_manufacturer: {
        type: String,
        default: "Manufacturer",
      },
      label_model: {
        type: String,
        default: "Model",
      },
      label_year: {
        type: String,
        default: "Year",
      },
      label_body_type: {
        type: String,
        default: "Body Type",
      },
      label_loading: {
        type: String,
        default: "Loading",
      },
      label_next: {
        type: String,
        default: "Next",
      },
      label_calculate: {
        type: String,
        default: "Calculate",
      },
      label_back: {
        type: String,
        default: "Back",
      },
      label_select: {
        type: String,
        default: "Select",
      },
      label_select_vehicle_label: {
        type: String,
        default: "Select Vehicle",
      },
      label_select_vehicle: {
        type: String,
        default: "Select Vehicle & next",
      },
      label_stockcode: {
        type: String,
        default: "Please select your Rhino-Rack System:",
      },
      label_vehicle_load_rating: {
        type: String,
        default:
        "Enter your specified vehicle roof loading in kilograms (kgs) as stated in your vehicle’s owner’s manual:",
      },
      label_vehicle_load_rating_us: {
        type: String,
        default:
        "Enter your specified vehicle roof loading in pounds (lbs) as stated in your vehicle’s owner’s manual:",
      },
      label_no_product_vehicle_match: {
        type: String,
        default: "We don't have a match for that vehicle/product",
      },
      label_no_fitment_available: {
        type: String,
        default: "We do not currently have a fitment available for this vehicle",
      },
      label_dynamic_load_rating: {
        type: String,
        default: "On-Road Load Rating",
      },
      label_static_load_rating: {
        type: String,
        default: "Static load rating",
      },
      label_offroad_load_rating: {
        type: String,
        default: "Off-Road Load Rating (excludes additional accessories)",
      },
      label_offroad_considerations: {
        type: String,
        default: "Off road considerations",
      },
      label_selected_vehicle: {
        type: String,
        default: "Selected Vehicle",
      },
      label_vehicle_loadrating: {
        type: String,
        default: "Your vehicle's load rating",
      },
      label_selected_product: {
        type: String,
        default: "Selected Product",
      },
      symbol_weight_unit: {
        type: String,
        default: "kg",
      },
      load_rating_disclaimer: {
        type: String,
        default: "",
      },
      load_rating_disclaimer_truck_bed: {
        type: String,
        default: "",
      },
      label_payload_capacity: {
        type: String,
        default: "Roof Rack Payload Capacity (excludes additional accessories)",
      },
      label_system_weight: {
        type: String,
        default: "Roof Rack System Weight (excludes additional accessories)",
      },
      label_payload_capacity_truck_bed: {
        type: String,
        default: "Truck Bed Payload Capacity (excludes additional accessories)",
      },
      label_system_weight_truck_bed: {
        type: String,
        default: "Truck Bed System Weight (excludes additional accessories)",
      },
      input_vehicle_roof_racks: {
        type: Object,
        default: {},
      },
      label_offroad_load_reduction_does_not_apply: {
        type: String,
        default: "(off-road load reduction does not apply to this roof rack system.)"
      },
      label_offroad_load_reduction_does_not_apply_truck_bed: {
        type: String,
        default: "(off-road load reduction does not apply to this truck bed system.)"
      },
      label_truck_bed_system_weight: {
        type: String,
        default: "Truck Bed System Weight (excludes additional accessories)",
      },
      label_truck_bed_payload_capacity: {
        type: String,
        default: "Truck Bed Cargo Capacity (excludes additional accessories)",
      },
      label_rhino_rack_system_load_limit: {
        type: String,
        default: 'Rhino-Rack System load limit (lbs):'
      },
      label_load_rating_truck_bed: {
        type: String,
        default: "Enter your truck bed load rating in pounds (lbs) as stated in your vehicle's owner’s manual, or by the vehicle manufacturer:"
      },
    },
    computed:{
     selectedProductObj() {
       if (this.isTruckBedProduct && 
           this.vehicleProductsApiResponse && 
           this.vehicleProductsApiResponse.length > 0) {
          return this.vehicleProductsApiResponse.find(product => product.productId === this.selectedProduct);
       }
      return this.vehicleRoofRacks.find(x => x.productId === this.selectedProduct);
    },
    selectedVehicleComputed() {
      return this.$store.state.solutions.selectedVehicle;
    },
    selectedProductLoadRatingLimit() {
      return this.selectedProductObj ? typeof this.selectedProductObj.loadRatingLimit == 'number' ?  this.selectedProductObj.loadRatingLimit : ''  : '';
    },
    isTruckBedProduct() {
      return this.input_vehicle_roof_racks.isTruckBedProduct == 1 ? true : false;
    },
    isRoofProduct() {
      return !this.isTruckBedProduct;
    },
    getVehicleId() {
      if(this.isTruckBedProduct) {
        return 4;
      }
      return '';
    }
  },
  mounted() {
    if(this.symbol_weight_unit === 'lbs') this.unitConvertor = 1;
    if(this.selectedVehicleComputed && this.selectedVehicleComputed.vehicleId) {
        this.vehicleId = this.selectedVehicleComputed.vehicleId;
        this.selectedVehicle = this.selectedVehicleComputed;
        this.selectedProduct = this.input_vehicle_roof_racks.productId;
        this.vehicleRoofRacks.push(this.input_vehicle_roof_racks);
        this.step++;
      }
    if(this.selectedVehicle) {
      this.fetchVehicleRoofracks();
    }
  },
  methods: {
    fetchVehicleRoofracks() {
      this.showNoFitmentAvailable= false
      this.loading = true;
      axios
      .get(
        this.apiVehicleProducts + this.selectedVehicle.vehicleId + '/true'
        )
      .then((response) => {
        this.loading = false;
        this.vehicleProductsApiResponse = response.data.data;
        if(!response.data.data.length){
          this.showNoFitmentAvailable= true
        }
        else {
          //this.vehicleRoofRacks = response.data.data;
          this.vehicleRoofRacks.push(this.input_vehicle_roof_racks);
          this.selectedProduct = this.input_vehicle_roof_racks.productId;
        }
      });
    },
    fetchRating($event) {
      if(this.isTruckBedProduct) {
        this.setTruckBedLoadRatingValue();
      }

      this.loading = true;
      axios
      .get(
        this.apiUrl +
        "?vehicleId=" +
        this.vehicleId +
        "&productId=" +
        this.selectedProduct +
        "&vehicleLoadRating=" +
        //Math.floor(this.vehicleLoadRating / this.unitConvertor)
        this.vehicleLoadRating
        )
      .then((response) => {
            this.apiLoadrating = response.data.data;
            this.apiSuccess = response.data.success;
            this.apiLoaded = true;
            this.loading = false;
          }).catch((err) => {
            this.loading = false;
          });
      this.triggerGA($event);

    },
    selectVehicleLoadrating(data) {
      // here goes the data from vehicle dropdown select
      if (data.data.vehicle && data.data.vehicle.vehicleId) {
        this.vehicleId = data.data.vehicle.vehicleId;
        this.selectedVehicle = data.data.vehicle;
        this.step++;
        this.fetchVehicleRoofracks();
      }
    },
    productSelected(data) {
      if (data.productId) {
        this.productId = data.productId;
        this.selectedProduct = data;
      }
    },
    setTruckBedLoadRatingValue() {
      if (this.ownerManualVehicleLoadRating && this.ownerManualVehicleLoadRating >= 0) {
        this.vehicleLoadRating = this.ownerManualVehicleLoadRating;
      } else {
        this.vehicleLoadRating = this.selectedProductLoadRatingLimit;
      }
      this.triggerGA();
    },
    triggerGA(event) {
      gtag('event', 'product_load_rating_calculator', {'category':'Product Load Rating Calulator', 'action':'Product Load Rating', 'value': this.vehicleLoadRating});
      gtag('event', 'product_load_rating_calculator', {'category':'Product Load Rating Calulator', 'action':'Rhino-Rack System', 'value': this.input_vehicle_roof_racks.stockCode});
    },
  },
};
</script>